import { useEffect } from "react";
import { Navigate, Route, BrowserRouter, Routes } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { jwtDecode } from "jwt-decode";
import { RoleProvider } from "./API/RoleContext";
import Designation from "./pages/designation/pages/Designation";
import Configuration from "./pages/configuration/pages/configuration";
import License from "./pages/license/pages/license";
import DomainSettings from "./pages/configuration/domain/pages/domainSettings";
import DeviceSettings from "./pages/configuration/device/pages/deviceSettings";
import EmailList from "./pages/emailLicensing/List/pages/emailList";
import ServerLicense from "./pages/serverlicense/pages/serverlicense";
import Reports from "./pages/reports/pages/reports";
import SoftwareDashboard from "./pages/license/pages/dashboard";
import AdminManagement from "./pages/adminManagement/pages/adminManagement";
import Approvals from "./pages/pending/pages/approvals";
import EmailDashboard from "./pages/emailLicensing/List/pages/dashboard";
import EmailGroups from "./pages/emailLicensing/List/pages/emailGroups";
import PendingTasks from "./pages/pendingTasks/pages/pendingTasks";
import LoginPage from "./pages/Login/Pages/Login";
import SpecialEmailList from "./pages/emailLicensing/List/pages/specialEmails";
import { getCookieToken } from "./Utils/utils";
import PrivateRoutes from "./API/PrivateRoutes";

function App() {
  const onCloseSnackBar = (event: any, reason: any) => {
    return;
  };

  useEffect(() => {
    document.title = "IT Management Application";
  }, []);

  const handleCookie = async () => {
    const token: string = (await getCookieToken()) as string;
    if (token && token !== undefined) {
      localStorage.setItem("token", token);
      const decodedValue = jwtDecode(token);
      localStorage.setItem("Decoded", JSON.stringify(decodedValue));
    }
  };

  useEffect(() => {
    handleCookie();
    const url = window.location.href;
    const lastSegment = url.split("/").filter(Boolean).pop();
    if (lastSegment !== "login") {
      const intervalId = setInterval(() => {
        handleCookie();
      }, 12 * 60 * 60 * 1000);

      return () => {
        clearInterval(intervalId);
      };
    }
  }, []);

  return (
    <SnackbarProvider
      autoHideDuration={2000}
      hideIconVariant={true}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      onClose={onCloseSnackBar}
      maxSnack={1}
    >
      <RoleProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route element={<PrivateRoutes />}>
                <Route path="/designation" element={<Designation />} />
                <Route element={<Configuration />} path="/configuration" />
                <Route element={<DomainSettings />} path="/domain" />
                <Route element={<DeviceSettings />} path="/device" />
                <Route element={<ServerLicense />} path="/server-license" />
                <Route
                  element={<SoftwareDashboard />}
                  path="/software-dashboard"
                />
                <Route element={<Approvals />} path="/approvals" />
                <Route element={<EmailDashboard />} path="/email-dashboard" />
                <Route element={<AdminManagement />} path="/admin-management" />
                <Route element={<Reports />} path="/reports" />
                <Route element={<License />} path="/license-management" />
                <Route element={<EmailList />} path="/email-list" />
                <Route element={<EmailGroups />} path="/email-groups" />
                <Route element={<SpecialEmailList />} path="/special-emails" />
                <Route element={<PendingTasks />} path="/pending" />
              </Route>

              <Route
                path="/login"
                element={
                  localStorage.getItem("token") ? (
                    <Navigate to="/software-dashboard" />
                  ) : (
                    <LoginPage />
                  )
                }
              />
              <Route path="/" element={<Navigate to="/software-dashboard" />} />
              <Route
                path="/*"
                element={<Navigate to="/software-dashboard" />}
              />
            </Routes>
          </BrowserRouter>
        </div>
      </RoleProvider>
    </SnackbarProvider>
  );
}

export default App;
